import { useDispatch } from "react-redux";

import IconButton from "@mui/material/IconButton";
import InfoOutlined from "@mui/icons-material/InfoOutlined";
import StyledTooltip from "./StyledTooltip";

import { uiActions } from "../../store";

import { basemapPosition } from "../../config/config.layout";
import { iconButtonStyle, styles } from "../../config/config.theme";

/**
 * Generates a button that opens the welcome modal
 * @returns {JSX.Element}
 */
const DataStepperButton = () => {
  const dispatch = useDispatch();
  const handleChange = (e) => {
    dispatch(uiActions.setShowDataStepperModal(true));
  };

  return (
    <>
      <StyledTooltip
        title="Open Welcome Interface"
        placement={
          basemapPosition.tooltipPlacement
            ? basemapPosition.tooltipPlacement
            : "right"
        }
        disableFocusListener
        enterTouchDelay={0}
      >
        <IconButton
          aria-label="basemap selection"
          variant="outlined"
          onClick={handleChange}
          sx={{
            ...iconButtonStyle,
            "&:hover": { backgroundColor: styles["background-primary"] },
            "&:active": { backgroundColor: styles["background-primary"] },
            "&:focus": { backgroundColor: styles["background-primary"] },
          }}
        >
          <InfoOutlined fontSize="1.5rem" color="primary" />
        </IconButton>
      </StyledTooltip>
    </>
  );
};

export default DataStepperButton;
